"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var dayjs_1 = __importDefault(require("dayjs"));
var pluralize_1 = __importDefault(require("pluralize"));
var v4_1 = __importDefault(require("uuid/v4"));
var dayjs_2 = __importDefault(require("@date-io/dayjs"));
var styles_1 = require("@material-ui/core/styles");
var pickers_1 = require("@material-ui/pickers");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var core_2 = require("@21st-night/core");
var ActionButtons_1 = __importDefault(require("../../ActionButtons"));
var Button_1 = __importDefault(require("../../Button"));
var IconButton_1 = __importDefault(require("../../IconButton"));
var TextField_1 = __importDefault(require("../../TextField"));
var LoadingIndicator_1 = __importDefault(require("../../LoadingIndicator"));
function getVerb(category) {
    switch (category.toLowerCase()) {
        case 'chapter':
        case 'chapters':
            return 'Complete';
        case 'problem':
        case 'problems':
        case 'parctice problem':
        case 'practice problems':
            return 'Do';
        case 'flash card':
        case 'flash cards':
        case 'flashcard':
        case 'flashcards':
        case 'card':
        case 'cards':
            return 'Review';
        case 'page':
        case 'pages':
        case 'article':
        case 'articles':
            return 'Read';
        case 'video':
        case 'videos':
            return 'Watch';
        default:
            return 'Complete';
    }
}
var WEEKDAYS = [
    { name: 'Sunday', index: 0 },
    { name: 'Monday', index: 1 },
    { name: 'Tuesday', index: 2 },
    { name: 'Wednesday', index: 3 },
    { name: 'Thursday', index: 4 },
    { name: 'Friday', index: 5 },
    { name: 'Saturday', index: 6 },
];
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            paddingBottom: theme.spacing(6),
        },
        sectionHeading: {
            fontSize: '1.2rem',
            marginTop: theme.spacing(4),
        },
        category: {
            display: 'flex',
            margin: theme.spacing(2, 0),
            alignItems: 'center',
        },
        name: {
            width: 200,
            margin: theme.spacing(0, 1),
        },
        count: {
            width: 42,
        },
        dayCheckboxes: {
            display: 'flex',
            marginLeft: 16,
        },
        dayCheckBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        dayCheckBoxLabel: {
            color: theme.palette.text.secondary,
            fontSize: '.8rem',
            marginBottom: -8,
        },
    });
});
var StudyPlanGenerator = function (_a) {
    var classNameProp = _a.className, onGenerate = _a.onGenerate, values = _a.values, onChangeStartDate = _a.onChangeStartDate, onChangeTestDate = _a.onChangeTestDate, onChangeStartWeekOn = _a.onChangeStartWeekOn, _b = _a.initialValues, initialValues = _b === void 0 ? {} : _b, other = __rest(_a, ["className", "onGenerate", "values", "onChangeStartDate", "onChangeTestDate", "onChangeStartWeekOn", "initialValues"]);
    var startDate = values.startDate, testDate = values.testDate, startWeekOn = values.startWeekOn;
    var classes = exports.useStyles();
    var _c = __read(react_1.useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(react_1.useState({
        startDate: '',
        testDate: '',
    }), 2), errors = _d[0], setErrors = _d[1];
    var _e = __read(react_1.useState(initialValues.categories || [
        {
            name: 'chapters',
            count: '10',
            id: v4_1.default(),
            weekDays: [0, 4],
            error: '',
            weekDaysError: '',
        },
        {
            name: 'practice problems',
            count: '80',
            weekDays: [0, 1, 2, 3, 5, 6],
            id: v4_1.default(),
            error: '',
            weekDaysError: '',
        },
    ]), 2), categories = _e[0], setCategories = _e[1];
    var addCategory = function () {
        setCategories(function (existing) { return __spreadArray(__spreadArray([], __read(existing)), [
            {
                name: '',
                count: '',
                id: v4_1.default(),
                error: '',
                weekDaysError: '',
                weekDays: [],
            },
        ]); });
    };
    var handleStartDateChange = function (date) {
        if (date && testDate && date > testDate) {
            onChangeTestDate(core_2.toDate(date));
        }
        onChangeStartDate(core_2.toDate(date));
    };
    var handleTestDateChange = function (date) {
        onChangeTestDate(core_2.toDate(date));
    };
    var handleCategoryChange = function (value, id, field) {
        var safeValue = value;
        if (field === 'count' && value !== '' && value <= 0) {
            safeValue = 1;
        }
        setCategories(function (cats) {
            return cats.map(function (category) {
                var _a;
                return category.id === id ? __assign(__assign({}, category), (_a = {}, _a[field] = safeValue, _a)) : category;
            });
        });
    };
    var orderedWeekDays = __spreadArray(__spreadArray([], __read(WEEKDAYS.slice(startWeekOn))), __read(WEEKDAYS.slice(0, startWeekOn)));
    var handleCategoryWeekDaysChange = function (checked, id, day) {
        setCategories(function (cats) {
            return cats.map(function (category) {
                return category.id === id
                    ? __assign(__assign({}, category), { weekDays: checked
                            ? __spreadArray(__spreadArray([], __read(category.weekDays)), [day]) : category.weekDays.filter(function (dayNumber) { return dayNumber !== day; }) }) : category;
            });
        });
    };
    var toggleAllCategoryWeekDays = function (id) {
        setCategories(function (cats) {
            return cats.map(function (category) {
                return category.id === id
                    ? __assign(__assign({}, category), { weekDays: category.weekDays.length === 0 ? [0, 1, 2, 3, 4, 5, 6] : [] }) : category;
            });
        });
    };
    var removeCategory = function (id) {
        setCategories(function (existing) { return existing.filter(function (category) { return category.id !== id; }); });
    };
    function validate() {
        var valid = true;
        if (!startDate) {
            valid = false;
            setErrors(function (errs) { return (__assign(__assign({}, errs), { startDate: 'Required' })); });
        }
        if (!testDate) {
            valid = false;
            setErrors(function (errs) { return (__assign(__assign({}, errs), { testDate: 'Required' })); });
        }
        if (startDate && testDate && testDate <= startDate) {
            valid = false;
            setErrors(function (errs) { return (__assign(__assign({}, errs), { testDate: 'Must be after start date' })); });
        }
        categories.forEach(function (category) {
            if (!category.count) {
                handleCategoryChange('Count is required', category.id, 'error');
                valid = false;
            }
            if (!category.weekDays.length) {
                handleCategoryChange('Please select at least one day', category.id, 'weekDaysError');
                valid = false;
            }
            var count = parseInt(category.count, 10);
            if (typeof count !== 'number' || count < 1) {
                handleCategoryChange('Count must be a positive integer', category.id, 'error');
                valid = false;
            }
            if (!category.name) {
                handleCategoryChange('Name is required', category.id, 'error');
                valid = false;
            }
            if (!category.name && !category.count) {
                handleCategoryChange('Name and count are required', category.id, 'error');
                valid = false;
            }
        });
        return valid;
    }
    function handleSubmit(event) {
        event.preventDefault();
        if (validate()) {
            setLoading(true);
            var start = startDate;
            var test = testDate;
            var startDay = dayjs_1.default(start);
            var testDay = dayjs_1.default(test);
            var days = testDay.diff(startDay, 'day');
            var itemDays = days;
            if (days > 21) {
                // Leave an empty week if test is more
                // than three weeks away.
                itemDays -= 7;
            }
            else if (days > 14) {
                // Leave an empty 4 days if test is more
                // than two weeks away.
                itemDays -= 4;
            }
            else if (days > 7) {
                // Leave an empty 2 days if test is more
                // than a week away.
                itemDays -= 2;
            }
            else {
                // Otherwise leave a ingle empty day
                itemDays -= 1;
            }
            var endDay = startDay.clone();
            endDay = endDay.add(itemDays, 'day');
            var weekDayCategories_1 = [[], [], [], [], [], [], []];
            var dayCounts_1 = [0, 0, 0, 0, 0, 0, 0];
            for (var i = startDay.toDate(); i <= endDay.toDate(); i.setDate(i.getDate() + 1)) {
                dayCounts_1[i.getDay()] += 1;
            }
            var categoryItemCounts_1 = categories.reduce(function (counts, category) {
                var _a;
                var days = 0;
                category.weekDays.forEach(function (index) {
                    days += dayCounts_1[index];
                });
                return __assign(__assign({}, counts), (_a = {}, _a[category.name] = {
                    fraction: Math.floor(parseInt(category.count, 10) / (days || 1)),
                    remainder: parseInt(category.count, 10) % (days || 1),
                    lastItemRange: 0,
                }, _a));
            }, {});
            categories.forEach(function (category) {
                category.weekDays.forEach(function (index) {
                    weekDayCategories_1[index].push(category.name);
                });
            });
            var studyPlanDays = [];
            var studyPlanitems_1 = [];
            var _loop_1 = function (i) {
                var dayId = v4_1.default();
                var weekDay = i.getDay();
                var dayCategories = weekDayCategories_1[weekDay];
                var dayitems = [];
                dayCategories.forEach(function (categoryName) {
                    console.log(categoryName, categoryItemCounts_1[categoryName]);
                    var count = categoryItemCounts_1[categoryName].fraction;
                    var remainder = categoryItemCounts_1[categoryName].remainder;
                    if (count > 0 || remainder > 0) {
                        if (remainder) {
                            count += 1;
                            categoryItemCounts_1[categoryName].remainder -= 1;
                        }
                        var item = {
                            done: false,
                            id: v4_1.default(),
                            date: new Date(i.getTime()),
                            day: dayId,
                            subItems: [],
                            createdAt: new Date(),
                            type: 'item',
                            title: core_2.createRichTextDocument([
                                getVerb(categoryName) + " " + (count === 1
                                    ? pluralize_1.default.singular(categoryName)
                                    : pluralize_1.default(categoryName)) + " " + (categoryItemCounts_1[categoryName].lastItemRange + 1) + (count > 1
                                    ? " - " + (categoryItemCounts_1[categoryName].lastItemRange + count)
                                    : ''),
                            ], true),
                        };
                        categoryItemCounts_1[categoryName].lastItemRange += count;
                        dayitems.push(item);
                        studyPlanitems_1.push(item);
                    }
                });
                studyPlanDays.push({
                    id: dayId,
                    date: new Date(i.getTime()),
                    items: dayitems.map(function (item) { return item.id; }),
                });
            };
            for (var i = startDay.toDate(); i <= endDay.toDate(); i.setDate(i.getDate() + 1)) {
                _loop_1(i);
            }
            var extraStudyPlanDays = [];
            for (var i2 = new Date(studyPlanDays.slice(-1)[0].date.getTime()); i2 <= test; i2.setDate(i2.getDate() + 1)) {
                extraStudyPlanDays.push({
                    id: v4_1.default(),
                    date: new Date(i2.getTime()),
                    items: [],
                });
            }
            onGenerate({
                days: __spreadArray(__spreadArray([], __read(studyPlanDays)), __read(extraStudyPlanDays)),
                items: studyPlanitems_1,
                startWeekOn: startWeekOn,
                startDate: startDate,
                categories: categories.map(function (category) { return ({
                    name: category.name,
                    count: category.count,
                    weekDays: category.weekDays,
                    id: category.id,
                }); }),
                testDate: testDay.toDate(),
            });
            setLoading(false);
        }
    }
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: dayjs_2.default },
            react_1.default.createElement("form", { onSubmit: handleSubmit },
                react_1.default.createElement(core_1.Typography, { className: classes.sectionHeading }, "1. When do you want to start studying for the test?"),
                react_1.default.createElement(pickers_1.KeyboardDatePicker, { autoOk: true, disableToolbar: true, disablePast: true, variant: "inline", format: "D MMMM, YYYY", margin: "dense", name: "start-date", value: startDate, onChange: handleStartDateChange, error: !!errors.startDate, helperText: errors.startDate, KeyboardButtonProps: {
                        'aria-label': 'change date',
                    } }),
                react_1.default.createElement(core_1.Typography, { className: classes.sectionHeading }, "2. When is the test?"),
                react_1.default.createElement(pickers_1.KeyboardDatePicker, { autoOk: true, disableToolbar: true, disablePast: true, minDate: startDate, error: !!errors.testDate, helperText: errors.testDate, variant: "inline", format: "D MMMM, YYYY", margin: "dense", name: "test-date", value: testDate, onChange: handleTestDateChange, KeyboardButtonProps: {
                        'aria-label': 'change date',
                    } }),
                react_1.default.createElement(core_1.Typography, { className: classes.sectionHeading }, "3. How many of each of these do you have to complete for the test?"),
                categories.map(function (category) { return (react_1.default.createElement("div", { key: category.id },
                    react_1.default.createElement("div", { className: classes.category },
                        react_1.default.createElement(TextField_1.default, { name: "count-" + category.id, id: "count-field-" + category.id, type: "number", value: category.count, variant: "underlined", placeholder: "10", className: classes.count, error: !!category.error &&
                                (category.error.startsWith('Count') ||
                                    category.error.startsWith('Name and count')), onChange: function (event) {
                                return handleCategoryChange(event.target.value, category.id, 'count');
                            } }),
                        react_1.default.createElement(TextField_1.default, { name: "name-" + category.id, id: "name-field-" + category.id, value: category.name, variant: "underlined", placeholder: "chapters", className: classes.name, error: !!category.error && category.error.startsWith('Name'), onChange: function (event) {
                                return handleCategoryChange(event.target.value, category.id, 'name');
                            } }),
                        react_1.default.createElement(IconButton_1.default, { size: "small", color: "inherit", onClick: function () { return removeCategory(category.id); } },
                            react_1.default.createElement(icons_1.RemoveCircleOutline, null))),
                    !!category.error && (react_1.default.createElement(core_1.FormHelperText, { error: true }, category.error)))); }),
                categories.length < 7 && (react_1.default.createElement(Button_1.default, { color: "primary", size: "small", onClick: addCategory }, "Add additional item")),
                react_1.default.createElement(core_1.Typography, { className: classes.sectionHeading }, "4. On which days of the week do you want to work on each of these?"),
                react_1.default.createElement("div", { className: classes.category },
                    react_1.default.createElement(core_1.Typography, { style: { marginRight: 16, fontWeight: 700 } }, "Start week on"),
                    react_1.default.createElement(core_1.FormControl, null,
                        react_1.default.createElement(core_1.Select, { value: startWeekOn, onChange: function (event) { return onChangeStartWeekOn(event.target.value); } }, WEEKDAYS.map(function (day) { return (react_1.default.createElement(core_1.MenuItem, { value: day.index }, day.name)); })))),
                react_1.default.createElement("table", null, categories.map(function (category) { return (react_1.default.createElement("tr", { key: category.id },
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(core_1.Typography, { style: { marginTop: 12 } }, category.name)),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement("div", { className: classes.dayCheckboxes },
                            orderedWeekDays.map(function (day) { return (react_1.default.createElement("div", { className: classes.dayCheckBox },
                                react_1.default.createElement(core_1.Typography, { className: classes.dayCheckBoxLabel }, day.name.slice(0, 3)),
                                react_1.default.createElement(core_1.Checkbox, { checked: category.weekDays.includes(day.index), onChange: function (event, checked) {
                                        return handleCategoryWeekDaysChange(checked, category.id, day.index);
                                    } }))); }),
                            react_1.default.createElement(Button_1.default, { size: "small", style: { marginTop: 10 }, onClick: function () {
                                    return toggleAllCategoryWeekDays(category.id);
                                } }, category.weekDays.length ? 'Clear' : 'Select all')),
                        !!category.weekDaysError && (react_1.default.createElement(core_1.FormHelperText, { error: true, style: { textAlign: 'center' } }, category.weekDaysError))))); })),
                react_1.default.createElement(ActionButtons_1.default, { align: "center", marginTop: true },
                    !loading && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", type: "submit" }, "Generate Study Plan")),
                    loading && react_1.default.createElement(LoadingIndicator_1.default, { size: "medium" }))))));
};
exports.default = StudyPlanGenerator;
//# sourceMappingURL=StudyPlanGenerator.js.map